<template lang="pug" src="./topBar.pug"></template>

<script>
import SuspendedMenu from './SuspendedMenu'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import toggleActiveListItem from '../../../utils/toggleActiveListItem.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'TopBar',

  components: {
    SuspendedMenu
  },

  data () {
    return {
      home: PATHS.HOME,
      username: null,
      clientActive: null
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },
    clientName () {
      return this.$store.getters.clientName
    },
    isOpen () {
      return this.$store.getters.isOpen
    }
  },

  watch: {
    user () {
      this.username = this.user
    },
    clientName () {
      if (this.clientName) {
        this.clientActive = this.clientName
      }
    }
  },

  methods: {
    clearSelectedMenuItem () {
      trackAnalyticsEvent(this, 'redirect-para-dashboard', 'banking-click', 'redirect-para-dashboard')
      this.$store.dispatch('clearSelectedMenuItem').then(() => {
        toggleActiveListItem()
      })
    }
  },

  mounted () {
    if (this.user) {
      this.username = this.user
    }
    if (this.clientName) {
      this.clientActive = this.clientName
    }
  }
}
</script>

<style lang="scss">
html body {
  font-style: normal;
  background-color: rgba(244, 244, 244, 1);
  -moz-appearance: none !important;
}

.header {
  border: none!important;
  height: 60px!important;
  z-index: 199!important;
  background: #142C4F;
  background: linear-gradient(to right, #142C4F, #3BB5B4);
  transition: all 150ms cubic-bezier(.05, .74, .27, .99);

  a > i {
    color: white;
  }

  .brand {
    width: 22px !important;
    margin-left: 20px;
  }

  .aplicacao-nome-topo {
    padding: 12px 0px 0px 13px;

    // Abaixo de 991px de largura.
    @media (max-width: 991px) {
      text-align: center;
    }

    // Acima de 991px de largura.
    @media (min-width: 992px) {
      float: left;
    }

    span {
      font-family: 'Inter', sans-serif;
font-weight: 700;
      color: #E5E5E5;
      font-size: 25px;
      text-transform: capitalize;
    }
  }

  .user-info {
    margin-right: 10px;
    font-size: 13px;
    color: #FFF;
    font-family: 'Inter', sans-serif;

    hr {
      border: none;
      clear: both;
      border-top: 1px solid #65BBC2;
      margin: -1px 0px 3px 0px;
    }

    span {
      float: right;

      &.user-info-client {
        font-weight: bold;
      }
    }
  }

  .top-user-icons {
    margin-right: 10px;
    width: 38px;
    height: 38px;
    border-radius: 19px;
    padding: 0px;
    display: block;
    background-color: #1E7F81;
    color: #EEE;
    font-size: 21px;
    text-align: center;

    .fa {
      padding-top: 7px;
    }

    a {
      display: block;
      color: #FFF;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// TopBar.vue?79ce9f3e